export default __webpack_public_path__ + "static/media/Godfather_icon.980b55e0.png";